import {
  SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT,
  LOAD_CHECKOUT,
  PROCESSING_STARTED,
  PROCESSING_FINISHED,
  UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT,
  UPDATE_CART_TOTAL_FOR_REG_CHECKOUT,
  UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT,
  SET_ALREADY_VALIDATED,
  CLEAR_PAYMENT,
  SET_TERMS_URL_FOR_REG_CHECKOUT,
  SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT,
  SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT,
  CREATE_CHECKOUT_PAYMENT,
  SHOW_PAYMENT_DIALOG_EMBEDDED_FORM
} from './constants';
import {
  DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN,
  SET_CURRENT_ROSTER_CART_ID
} from '../shared/constants';

const initialState = {
  cart: null,
  total: 0,
  processing: false,
  showClearCartConfirmation: false,
  disablePayInFull: true,
  alreadyValidated: false,
  termsUrl: '',
  agreedToTerms: false,
  validationMessages: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT:
      return {
        ...state,
        disablePayInFull: typeof payload !== 'undefined' && payload !== null
          ? payload
          : initialState.disablePayInFull
      };
    case DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN:
      return {
        ...state,
        showClearCartConfirmation: payload
      };
    case LOAD_CHECKOUT: {
      let cart = payload;
      let squadsInCart = cart.squads,
        virtualEventsInCart = cart.virtualEvents;
      let eventsInCart = cart.squads.concat(cart.virtualEvents.filter(virtualEvent => virtualEvent.eventId));

      eventsInCart.forEach(event => {
        if (!event.eventNumberOfBowlers) {
          let mappedEvent = eventsInCart.find(innerEvent => innerEvent.eventNumberOfBowlers && innerEvent.eventId === event.eventId);

          if (mappedEvent) {
            event.eventNumberOfBowlers = mappedEvent.eventNumberOfBowlers;
          }
        }
      });

      let bowlerOwnedVirtualEvents = cart.virtualEvents.filter(virtualEvent => !virtualEvent.eventId);

      const total = squadsInCart.reduce((a, b) => a + b.eventTotalPrice * b.quantity, 0)
        + virtualEventsInCart.reduce((a, b) => a + b.price * b.quantity, 0);

      return {
        ...state,
        ...{
          cart: cart,
          total: total,
          amount: total.toFixed(2).replace(/\./, ''),
          description: squadsInCart.map(item => item.summary).join(','),
          eventsInCart: eventsInCart,
          bowlerOwnedVirtualEvents: bowlerOwnedVirtualEvents
        }
      };
    }

    case PROCESSING_STARTED:
      return {
        ...state,
        ...{
          processing: true
        }
      };

    case PROCESSING_FINISHED:
      return {
        ...state,
        ...{
          processing: false
        }
      };
    case UPDATE_CART_TOTAL_FOR_REG_CHECKOUT: {
      let squadsInCart = state.cart.squads,
        virtualEventsInCart = state.cart.virtualEvents;
      const total = squadsInCart.reduce((a, b) => a + b.eventTotalPrice * b.quantity, 0)
        + virtualEventsInCart.reduce((a, b) => a + b.price * b.quantity, 0);

      return {
        ...state,
        total
      };
    }
    case UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT:
      return {
        ...state,
        cart: {
          ...state.cart,
          squads: state.cart.squads.map(x => squadReducer(x, { type, payload }))
        }
      };
    case SET_ALREADY_VALIDATED:
      return {
        ...state,
        alreadyValidated: payload
      };
    case UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT:
      return {
        ...state,
        cart: {
          ...state.cart,
          virtualEvents: state.cart.virtualEvents.map(x => virtualEventReducer(x, { type, payload }))
        }
      };
    case SET_CURRENT_ROSTER_CART_ID: {
      const cart = state.cart;
      const squadsInCart = cart.squads.slice();
      const virtualEventsInCart = cart.virtualEvents.slice();
      let editingCartEntry = squadsInCart.find(squad => squad.cartRosterId == payload.oldId);

      if (!editingCartEntry) {
        editingCartEntry = virtualEventsInCart.find(cartEntry => cartEntry.cartRosterId == payload.oldId);
      }

      if (editingCartEntry) {
        editingCartEntry.cartRosterId = payload.newId;
      }

      return {
        ...state,
        cart: {
          ...cart,
          squads: squadsInCart,
          virtualEvents: virtualEventsInCart
        }
      };
    }
    case CLEAR_PAYMENT:
      return initialState;

    case SET_TERMS_URL_FOR_REG_CHECKOUT:
      return {
        ...state,
        termsUrl: payload
      };

    case SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT:
      return {
        ...state,
        validationMessages: payload
      };

    case SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT:
      return {
        ...state,
        agreedToTerms: payload
      };

    case CREATE_CHECKOUT_PAYMENT:
      console.log('CREATE_CHECKOUT_PAYMENT', payload);
      return {
        ...state,
        checkoutPayment: payload
      };

    case SHOW_PAYMENT_DIALOG_EMBEDDED_FORM:
      return {
        ...state,
        showPaymentDialog: payload
      };

    default:
      return state;
  }
};

const squadReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT:
      return state.id === payload.squadId
        ? {
          ...state,
          quantity: Number(payload.inputValue)
        }
        : state;
    default:
      return state;
  }
};

const virtualEventReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT:
      return state.id === payload.virtualEventId
        ? {
          ...state,
          quantity: Number(payload.inputValue)
        }
        : state;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/registration/checkout/reducer.js